import type { z } from "zod";
import type {
  WidgetCreateAction,
  WidgetPatchAction,
  WidgetLockAction,
  WidgetSyncAction,
} from "@ever-tutor/et-widgets/core";
import { applyWidgetAction } from "@ever-tutor/et-widgets/tldraw";
import type { Streaming } from "../../shared/types/Streaming";
import { AgentActionUtil, registerActionUtil } from "./AgentActionUtil";

export const WidgetCreateActionUtil = registerActionUtil(
  class extends AgentActionUtil<z.infer<typeof WidgetCreateAction>> {
    static override type = "widget-create" as const;
    override applyAction(
      action: Streaming<z.infer<typeof WidgetCreateAction>>,
    ) {
      if (action.complete) {
        const { complete, time, ...wire } = action;
        try {
          applyWidgetAction(this.editor, wire);
        } catch (error) {
          console.warn("Widget action rejected on canvas", error);
        }
      }
    }
  },
);
export const WidgetPatchActionUtil = registerActionUtil(
  class extends AgentActionUtil<z.infer<typeof WidgetPatchAction>> {
    static override type = "widget-patch" as const;
    override applyAction(action: Streaming<z.infer<typeof WidgetPatchAction>>) {
      if (action.complete) {
        const { complete, time, ...wire } = action;
        try {
          applyWidgetAction(this.editor, wire);
        } catch (error) {
          console.warn("Widget action rejected on canvas", error);
        }
      }
    }
  },
);
export const WidgetLockActionUtil = registerActionUtil(
  class extends AgentActionUtil<z.infer<typeof WidgetLockAction>> {
    static override type = "widget-lock" as const;
    override applyAction(action: Streaming<z.infer<typeof WidgetLockAction>>) {
      if (action.complete) {
        const { complete, time, ...wire } = action;
        try {
          applyWidgetAction(this.editor, wire);
        } catch (error) {
          console.warn("Widget action rejected on canvas", error);
        }
      }
    }
  },
);

export const WidgetSyncActionUtil = registerActionUtil(
  class extends AgentActionUtil<z.infer<typeof WidgetSyncAction>> {
    static override type = "widget-sync" as const;
    override applyAction(action: Streaming<z.infer<typeof WidgetSyncAction>>) {
      if (action.complete) {
        try {
          applyWidgetAction(this.editor, action);
        } catch (error) {
          console.warn("Widget resynchronization rejected on canvas", error);
        }
      }
    }
  },
);
